import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { ActiveSpaceHandler } from './ActiveSpaceHandler/ActiveSpaceHandler';
import { BadgeHandler } from './BadgeHandler/BadgeHandler';
import { ChangeActiveGroupHandler } from './ChangeActiveGroupHandler/ChangeActiveGroupHandler';
import { CompactViewCalendar } from './CompactViewCalendar/CompactViewCalendar';
import { ConfirmUnreadMessages } from './ConfirmUnreadMessages/ConfirmUnreadMessages';
import { DeepLinkHandler } from './DeepLinkHandler/DeepLinkHandler';
import { ElectronIPCPairer } from './ElectronIPCPairer/ElectronIPCPairer';
import ForceUpdateHandler from './ForceUpdateHandler';
import IsFocusedAppHandler from './IsFocusedAppHandler';
import { useModulesPresenter } from './Modules.presenter';
import { RoomCallHandler } from './RoomCallHandler/RoomCallHandler';
import ThreadCounterHandler from './ThreadCounterHandler';
import { UpdateMessagesInViewportHandler } from './UpdateMessagesInViewportHandler/UpdateMessagesInViewportHandler';

export const Modules: FC = observer(() => {
  const presenter = useModulesPresenter();

  return (
    <>
      <ChangeActiveGroupHandler />
      <IsFocusedAppHandler />
      <ForceUpdateHandler />
      <BadgeHandler />
      <ThreadCounterHandler />
      {presenter.isNeedHandleDeepLink && (
        <DeepLinkHandler finishDeepLinkHandling={presenter.finishDeepLinkHandling} />
      )}
      <UpdateMessagesInViewportHandler />
      <ConfirmUnreadMessages />
      <ActiveSpaceHandler />
      <RoomCallHandler />
      <CompactViewCalendar />
      <ElectronIPCPairer />
    </>
  );
});
